/*
 * Copyright (c) 2021 SARL SIGMA POLYNESIA
 */

import { stringify } from 'qs'
import rest from '../../../../client/js/lib/rest'
import { HalDocument } from '@jalik/hal'
import { handleBlobResponse } from '../../../../client/js/lib/download'

export function deleteCustomer (id: number) {
  return rest.delete(`/api/customers/${id}`)
}

export function downloadCustomerVCards (params?: Record<string, any>): Promise<Blob> {
  return rest.get(`/api/customers/vcards?${stringify(params)}`)
    .then(handleBlobResponse)
}

export function fetchCustomer (id: number): Promise<Customer> {
  return rest.get(`/api/customers/${id}`)
    .then((resp) => resp.json())
}

export function fetchCustomerReportData (id: number, params?: Record<string, unknown>) {
  return rest.get(`/api/customers/${id}/report?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function findManyCustomers (params?: Record<string, any>): Promise<HalDocument<{
  customers: Customer[]
}>> {
  return rest.get(`/api/customers?${stringify(params)}`)
    .then((resp) => resp.json())
}

export function patchCustomer (id: number, data: Partial<Customer>) {
  return rest.patch(`/api/customers/${id}`, {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}

export function postCustomer (data: Partial<Customer>) {
  return rest.post('/api/customers', {
    headers: { 'content-type': 'application/json' },
    body: JSON.stringify(data)
  }).then((resp) => resp.json())
}
